import * as React from 'react';
import Button, { IButtonProps } from '.';

export interface IFileButtonProps {
  children?: React.ReactNode;
  color?: IButtonProps['color'];
  size?: IButtonProps['size'];
  loading?: IButtonProps['loading'];
  rounded?: IButtonProps['rounded'];
  className?: IButtonProps['className'];
  multiple?: HTMLInputElement['multiple'];
  accept?: HTMLInputElement['accept'];
  inputRef?: React.Ref<HTMLInputElement>;
  onSelect?: (files: FileList) => void;
}

const FileButton = ({
  children,
  multiple,
  accept,
  inputRef,
  onSelect,
  ...props
}: IFileButtonProps) => {
  const handleInputChange = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    if (!onSelect || !event.target.files) {
      return;
    }

    onSelect(event.target.files);
  }, [onSelect]);

  return (
    <Button {...props}>
      <input
        type="file"
        multiple={multiple}
        accept={accept}
        ref={inputRef}
        onChange={handleInputChange}
      />
      {children}
    </Button>
  );
};

export default FileButton;



// WEBPACK FOOTER //
// ./src/components/Button/FileButton.tsx